export default __webpack_public_path__ + "static/media/playstore.f80b781e.svg";